const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

const validatePassword = (password: string, passwordRepetition: string): string | null => {
  const isPasswordValid =
    stringHasLength(password, 8) &&
    stringContainsUpperCase(password) &&
    stringContainsNumber(password) &&
    stringContainsSpecialChar(password);

  if (!isPasswordValid)
    return 'Das Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Großbuchstaben, eine Zahl und ein Sonderzeichen enthalten.';

  if (password != passwordRepetition) return 'Die Passwörter stimmen nicht überein.';

  return null;
};

const stringHasLength = (value: string, length: number): boolean => value.length > length;

const stringContainsUpperCase = (value: string): boolean => /[A-Z]/.test(value);

const stringContainsNumber = (value: string): boolean => /\d/.test(value);

const stringContainsSpecialChar = (value: string): boolean => specialChars.test(value);

const validate = {
  validatePassword,
};

export default validate;
